const map = require('lodash/map')
const get = require('lodash/get')

const {impressionProperties} = require('../events/impression-events')
const globalProperties = require('./global-properties')

let impressionCheckList = []
const impressionEventQueue = []
const impressionCountedList = []
let tracker = null

function isElementInViewport(element) {
  if (!element) {
    return false
  }
  const rect = element.getBoundingClientRect()
  return (
    rect.top >= 0 &&
    rect.left >= 0 &&
    rect.bottom <=
      (window.innerHeight || document.documentElement.clientHeight) &&
    rect.right <= (window.innerWidth || document.documentElement.clientWidth)
  )
}

function isElementOutOfViewport(element) {
  if (!element) {
    return false
  }
  const rect = element.getBoundingClientRect()
  return (
    rect.top >= (window.innerHeight || document.documentElement.clientHeight) ||
    rect.left >= (window.innerWidth || document.documentElement.clientWidth) ||
    rect.bottom <= 0 ||
    rect.right <= 0
  )
}

function trackImpress(index, elem, eventName, properties) {
  return function doTrackImpress() {
    if (isElementInViewport(elem)) {
      tracker.track(eventName, properties)
      impressionCheckList.splice(index, 1, null)
      impressionCountedList[index] = elem
    }
    clearTimeout(impressionEventQueue[index])
    impressionEventQueue[index] = null
  }
}

function scanImpression() {
  if (typeof impressionCheckList !== 'object' || !tracker) {
    setTimeout(scanImpression, 1000)
    return
  }

  for (let i = 0; i < impressionCheckList.length; i += 1) {
    const elem = impressionCheckList[i]
    const globalProps = globalProperties()
    const isContentSystemLayout =
      get(globalProps, 'layout_id') && get(globalProps, 'layout_name')

    if (elem !== null && isElementInViewport(elem)) {
      let properties = {
        ui_element_type: elem.dataset.uiElementType,
        ui_element_name: elem.dataset.uiElementName,
        ui_element_id: elem.dataset.uiElementId || null,
        content_type: elem.dataset.contentType,
        content_name: elem.dataset.contentName,
        content_id: `${elem.dataset.contentId}`,
        content_position: Number(elem.dataset.contentPosition),
        content_merchant: elem.dataset.contentMerchant,
        content_misc: elem.dataset.contentMisc,
        feature_type: elem.dataset.featureType,
        feature_name: elem.dataset.featureName,
        feature_id: `${elem.dataset.featureId}`,
        feature_position: Number(elem.dataset.featurePosition),
        feature_merchant: elem.dataset.featureDestination,
        offer_id: `${elem.dataset.offerId}`,
        offer_type: elem.dataset.offerType,
        offer_name: elem.dataset.offerName,
        offer_merchant: elem.dataset.offerMerchant,
      }

      if (!isContentSystemLayout) {
        properties = {
          ...properties,
          curation_type: elem.dataset.curationType || 'manual',
          curation_id: elem.dataset.curationId || null,
        }
      }

      if (elem.dataset.affiliateId) {
        properties.affiliate_id = elem.dataset.affiliateId
      }
      if (!impressionEventQueue[i]) {
        impressionEventQueue[i] = setTimeout(
          trackImpress(
            i,
            elem,
            elem.dataset.impressionEvent,
            impressionProperties(properties, globalProps),
          ),
          2000,
        )
      }
    }

    if (elem !== null && isElementOutOfViewport(elem)) {
      clearTimeout(impressionEventQueue[i])
      impressionEventQueue[i] = null
    }
  }

  for (let i = 0; i < impressionCountedList.length; i += 1) {
    const elem = impressionCountedList[i]
    if (isElementOutOfViewport(elem)) {
      impressionCheckList[i] = elem
    }
  }
}

function scanImpressionElements(containerSelector) {
  const lazyloadedElement = document.querySelectorAll(
    `${containerSelector} ` + `[data-impression-event]`,
  )
  for (let i = 0; i < lazyloadedElement.length; i++) {
    impressionCheckList.push(lazyloadedElement[i])
  }
}

function init(currentTracker) {
  if (window && document) {
    window.addEventListener('load', (event) => {
      tracker = currentTracker
      impressionCheckList = document.querySelectorAll('[data-impression-event]')
      impressionCheckList = Array.prototype.slice.call(impressionCheckList)
      scanImpression()
    })
    window.addEventListener('scroll', (e) => {
      scanImpression()
    })
  }
}

function register(elem, propertiesData) {
  elements.push(elem)
  map(propertiesData, (property, key) => {
    elem.dataset[key] = property
  })
  elem.dataset.impressionEvent =
    propertiesData.impressionEvent || 'Web.Impression.Content'
  scanImpression()
}

if (window) {
  window.scanImpression = scanImpression
  window.scanImpressionElements = scanImpressionElements
}

module.exports = {
  init,
  register,
}
